(function () {
  const store = window.ScrubLabTeams.store;

  const EMBROIDERY_VARIANTS = {
    text: 34416607264812,
    logo: 46251648778284
  };

  let isSubmitting = false;

  function getEmbroideryVariant(type) {
    const value = String(type || '').trim().toLowerCase();

    if (value === 'text') {
      return EMBROIDERY_VARIANTS.text;
    }

    if (value === 'logo' || value === 'both') {
      return EMBROIDERY_VARIANTS.logo;
    }

    return null;
  }

  function buildCartItems() {
    const cartItems = [];

    store.state.items.forEach((item) => {
      const properties = item.embroidery?.properties || {};

      // A unique identifier links the garment to its embroidery.
      const bundleItemId = item.id;

      const garmentProperties = {
        ...properties,
        '_Scrub Lab Bundle': 'Yes',
        '_Bundle Item ID': bundleItemId
      };

      // Add the garment.
      cartItems.push({
        id: Number(item.variantId),
        quantity: Number(item.quantity),
        properties: garmentProperties
      });

      // Add embroidery charges for each configured side.
      ['Left', 'Right'].forEach((side) => {
        const type = properties[`${side} Chest Type`];
        const embroideryVariant = getEmbroideryVariant(type);

        if (!embroideryVariant) return;

        cartItems.push({
          id: embroideryVariant,
          quantity: Number(item.quantity),
          properties: {
            '_Scrub Lab Bundle': 'Yes',
            '_Bundle Item ID': bundleItemId,
            '_Linked Product': String(item.variantId),
            '_Embroidery Add-on': `${side} Chest ${type}`
          }
        });
      });
    });

    return cartItems;
  }

  store.addBundleToCart = async function () {
    if (isSubmitting || !store.state.items.length) return;

    const button = store.root.querySelector(
      '[data-add-bundle-to-cart]'
    );

    const message = store.root.querySelector(
      '[data-checkout-message]'
    );

    isSubmitting = true;

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding bundle...';
    }

    if (message) {
      message.textContent = 'Adding your bundle to the cart...';
    }

    try {
      const cartItems = buildCartItems();

      console.log('Submitting Scrub Lab bundle:', cartItems);

      const response = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: cartItems
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add the bundle.'
        );
      }

      console.log('Scrub Lab bundle added:', result);

const cartResponse = await fetch(
  (window.Shopify?.routes?.root || '/') + 'cart.js',
  { credentials: 'same-origin' }
);

if (!cartResponse.ok) {
  throw new Error('Unable to verify cart quantities. Please check your cart.');
}

const cart = await cartResponse.json();

const expectedQuantities = new Map();

cartItems.forEach((item) => {
  const key = `${item.id}:${item.properties['_Bundle Item ID']}`;
  expectedQuantities.set(
    key,
    (expectedQuantities.get(key) || 0) + item.quantity
  );
});

const missingItems = [...expectedQuantities].filter(([key, expected]) => {
  const [variantId, bundleItemId] = key.split(':');

  const actual = cart.items
    .filter((item) =>
      String(item.variant_id) === variantId &&
      String(item.properties?.['_Bundle Item ID']) === bundleItemId
    )
    .reduce((total, item) => total + item.quantity, 0);

  return actual < expected;
});

if (missingItems.length) {
  throw new Error(
    'Some bundle items could not be added in the requested quantities. Please review your cart.'
  );
}

      if (message) {
        message.textContent = 'Bundle added successfully!';
      }

      // Open Shopify's actual cart page for initial testing.
      // We'll integrate the theme's cart drawer afterward.
      window.location.assign(
        (window.Shopify?.routes?.root || '/') + 'cart'
      );

    } catch (error) {
      console.error('Scrub Lab cart error:', error);

      if (message) {
        message.textContent =
          error.message ||
          'Unable to add your bundle. Please try again.';
      }

      if (button) {
        button.disabled = false;
        button.textContent = 'Add Bundle to Cart';
      }

    } finally {
      isSubmitting = false;
    }
  };
})();